import { TableRow } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Redirect } from 'react-router-dom';
import iconoCheklist from '../../../src/assets/images/iconos/icono-checklist.png';
import OrigenSolicitud, { esOrigenSolicitud, puedeVerSolicitudOrigen } from './OrigenSolicitud.jsx';
import Timezone from '../../commons/timezone/Timezone.js';
import {
  StyledTableCellProps as StyledTableCell,
  StyledTooltip,
} from '../../commons/utils/TableStyles';
import { PRIORIDAD } from '../../commons/constants/prioridad.js';
import Security from '../../commons/security/Security.js';
import swal2 from 'sweetalert2';
import * as Utils from '../../commons/utils/Utils';

const TicketsGridTableRow = (props) => {
  const intl = useIntl();
  const [ticket, setTicket] = useState(props.ticket);
  const columnsEnabled = props.columnsEnabled;
  // Config del cliente Y elección del usuario, ya combinadas por la grilla
  // (useColumnVisibility). Ver la nota equivalente en TicketsGridRow.
  const columnasVisibles = props.columnasVisibles || {};
  const [redirectTo, setRedirectTo] = useState(null);
  const [totalPresupuesto, setTotalPresupuesto] = useState(0);
  const prioridadOptions = PRIORIDAD.map(option => ({
    ...option,
    nombre: intl.formatMessage({ id: `ticketsGrid.column_priority.${option.id}`, defaultMessage: option.nombre })
  }));
  const [prioridades, setPrioridades] = useState(prioridadOptions);

  useEffect(() => {
    if (columnsEnabled.mostrarTotalPresupuesto) {
      setTotalPresupuesto(ticket.presupuesto_total);
    }
  } ,[]);

  const goToTicket = (e) => {
    e.preventDefault();
    setRedirectTo(props.ticketUrl);
  };

  const TicketGridCell = ({
    show = true,
    className,
    onClick = goToTicket,
    align = 'left',
    style,
    children,
  }) => {
    return (
      <StyledTableCell
        show={show}
        className={className}
        /*
         * `onClick={false}` es como las celdas de esta grilla dicen "no navegues al ticket"
         * (la de prioridad, que tiene su propio dropdown). No se puede resolver con el valor
         * por defecto del parámetro, porque solo aplica a undefined. Se traduce acá: React
         * espera una función o undefined, y con un boolean avisa por consola.
         */
        onClick={onClick === false ? undefined : onClick}
        align={align}
        style={style}
      >
        {children}
      </StyledTableCell>
    );
  };

  const cambiarPrioridad = (prioridad) => {

    swal2.fire({
      title: intl.formatMessage({ id: 'tickets.cambiar_prioridad.titulo_modal', defaultMessage: 'Prioridad de Tickets' }),
      text: intl.formatMessage({ id: 'tickets.cambiar_prioridad.texto_modal', defaultMessage: 'Vas a realizar un cambio de prioridad de Tickets' }),
      type: "warning",
      confirmButtonColor: "#0ABFBC",
      confirmButtonText: intl.formatMessage({ id: 'tickets.cambiar_prioridad.boton.cambiar', defaultMessage: 'Cambiar' }),
      cancelButtonColor: "#FF3145",
      cancelButtonText: intl.formatMessage({ id: 'tickets.cambiar_prioridad.boton.cancelar', defaultMessage: 'Cancelar' }),
      showCancelButton: true,
    }).then((result) => {
      if (result.value && result.value === true) {
        Utils.sendData("/tickets/cambiarPrioridad/" + ticket.ticket_id, "POST", JSON.stringify({ prioridad }))
          .then(() => {
            let ticketCopy = JSON.parse(JSON.stringify(ticket));
            ticketCopy.prioridad = prioridad;
            setTicket(ticketCopy);
            swal2.fire(
              intl.formatMessage({ id: 'El_cambio_fue_guardado_con_Exito!', defaultMessage: 'El cambio fue guardado con Éxito!' }),
              " ",
              'success'
            );
          });
      }
    }
    );
  }

  const formatTiempoEnTallerGrilla = Utils.formatTiempoEnTaller;

  return (
    <>
      {redirectTo && <Redirect push to={redirectTo} />}

      <TableRow className="all cursor-pointer action edit">
        <StyledTableCell show={props.generacionMasiva} style={{ maxWidth: '30px' }}>
          <input
            type="checkbox"
            checked={props.selectedTickets.includes(ticket.ticket_id)}
            onChange={props.handleChecked(ticket.ticket_id)}
            style={{ maxWidth: '22px' }}
            className="customCheckbox cursor-pointer"
            id={ticket.ticket_id}
          />
        </StyledTableCell>

        <TicketGridCell show={columnasVisibles.ticketTipo}>
          <div className="d-flex">
            <StyledTooltip title={props.ticketTipo} arrow placement="top">
              <div className={getAvatarTipo(ticket.tipo) + ' avatar dt-user-avatar'}>
                {props.ticketTipo ? props.ticketTipo.substr(0, 1) : ''}
              </div>
            </StyledTooltip>
          </div>
        </TicketGridCell>

        <TicketGridCell show={columnasVisibles.id}
          onClick={() => {
            if (esOrigenSolicitud(ticket.origen, ticket.solicitud_id)) {
              if (puedeVerSolicitudOrigen()) setRedirectTo(`/solicitudes/${ticket.solicitud_id}`);
              return;
            }
            setRedirectTo(`formulario/${ticket.formulario}`);
          }}
        >
          {esOrigenSolicitud(ticket.origen, ticket.solicitud_id) ? (
            <OrigenSolicitud solicitudId={ticket.solicitud_id} ticketId={ticket.ticket_id} />
          ) : ticket.origen === 'Checklist' && ticket.formulario_id ? (
            <StyledTooltip title={ticket.formulario_id} arrow placement="top">
              <div
                className=""
                style={{ textAlign: 'center', display: 'flex', alignItems: 'center' }}
              >
                <img
                  src={iconoCheklist}
                  alt={ticket.origen}
                  width="24"
                  height="24"
                  style={{ marginRight: '10px' }}
                />
                <span>{ticket.ticket_id}</span>
              </div>
            </StyledTooltip>
          ) : (
            <div>
              <span style={{ marginLeft: '10px' }}>{ticket.ticket_id}</span>
            </div>
          )}
        </TicketGridCell>

        {/*
          * La columna OS existe en el thead desde que se agregó el flag
          * tickets.showExternalTicketId.habilitado, pero esta variante de fila (la de la
          * tabla ticket_grid) nunca tuvo su celda: con el flag prendido el header quedaba
          * con una columna más que las filas y todo el resto se corría un lugar.
          */}
        <TicketGridCell show={columnasVisibles.clientExternalTicketId}>
          {ticket.client_external_ticket_id ? ticket.client_external_ticket_id : null}
        </TicketGridCell>

        <TicketGridCell show={columnasVisibles.indicador}
          className={
            ticket.estado_color === 4
              ? 'status-yellow'
              : ticket.estado_color === 2
                ? 'status-red'
                : ticket.estado_color === 1
                  ? 'status-green'
                  : 'status-grey'
          }
        ></TicketGridCell>

        <TicketGridCell show={columnasVisibles.estado}>{props.ticketEstado}</TicketGridCell>
        <TicketGridCell show={columnasVisibles.prioridad} onClick={false}>
        <div className="d-flex align-items-center"
            style={{
              backgroundColor: (prioridades.find(p => p.id === ticket.prioridad) || prioridades.find(p => p.id === 'np')).color,
              padding: "4px",
              borderRadius: "7px",
              color: "white",
              fontSize: "9px",
              backgroundSize: "auto",
              width: "fit-content",
              border: "1px solid"
            }}
          >
            {(prioridades.find(p => p.id === ticket.prioridad) || prioridades.find(p => p.id === 'np')).nombre}
            {Security.hasPermission('TICKETS_CAMBIAR_PRIORIDAD') ?
              <div>
                <i
                  id="dLabel"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  className="fa fa-chevron-down cursor-pointer"
                  style={{ marginRight: "5px", marginLeft: "5px" }}
                ></i>
                <div className="dropdown-menu" aria-labelledby="dLabel">
                  {prioridades ?
                    prioridades.map((prioridad, i) => {
                      return prioridad.id !== ticket.prioridad ? (
                        <p
                          key={i}
                          className="dropdown-item"
                          style={{
                            cursor: "pointer",
                            margin: "0",
                            padding: "5px 5px",
                            borderLeft: "solid " + prioridad.color
                        }}
                          onClick={() => cambiarPrioridad(prioridad.id)}
                        >
                          {prioridad.nombre}
                        </p>
                      ) : null;
                    })
                    : ""}
                </div>
              </div>
              : null}
          </div>
        </TicketGridCell>
        <TicketGridCell show={columnasVisibles.nivelAprobacionPresupuesto}>
          {ticket.nivel_aprobacion}
        </TicketGridCell>

        <TicketGridCell show={columnasVisibles.fechaHoraAlta}>
          {ticket.fecha_hora_alta
            ? Timezone.getDateForClient(ticket.fecha_hora_alta, 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY')
            : ''}
        </TicketGridCell>

        <TicketGridCell show={columnasVisibles.usuarioCreacion}>
          {ticket.usuarioCreacionNombreApellido ? ticket.usuarioCreacionNombreApellido : <FormattedMessage id="ticketsGrid.column_usuario_creacion.generacion_automatica" defaultMessage="Generación automática" />}
        </TicketGridCell>

        <TicketGridCell show={columnasVisibles.detalle}>
          <StyledTooltip title={ticket.detalle || ''} arrow placement="top">
            <div className="text-truncate" style={{ maxWidth: '150px' }}>
              {ticket.detalle}
            </div>
          </StyledTooltip>
        </TicketGridCell>

        <TicketGridCell show={columnasVisibles.servicio}>{ticket.servicio}</TicketGridCell>

        <TicketGridCell show={columnasVisibles.entidad}>
          <button
            className="px-0 btn btn-sm btn-ic n btn-dt-grid text-dark"
            title={intl.formatMessage({
              id: 'ticketsGrid.column_actions.button_title_trabajar_con_ticket',
              defaultMessage: 'Trabajar con ticket',
            })}
            data-togle="tooltip"
            data-placement="top"
          >
            <GetEntidadIcon ticket={ticket} />
            {ticket.entidad}
          </button>
        </TicketGridCell>

        <TicketGridCell show={columnasVisibles.vin}>{ticket.movilVin}</TicketGridCell>
        <TicketGridCell show={columnasVisibles.unidad}>{ticket.unidad}</TicketGridCell>
        <TicketGridCell show={columnasVisibles.transportadora}>{ticket.transportadora_nombre}</TicketGridCell>
        <TicketGridCell show={columnasVisibles.rentadora}>{ticket.rentadora}</TicketGridCell>

        <TicketGridCell show={columnasVisibles.gerenciador}>{ticket.gerenciador}</TicketGridCell>
        <TicketGridCell show={columnasVisibles.mostrarTotalPresupuesto}>
          { totalPresupuesto === 0 || 
            totalPresupuesto === "0.000" ||
            totalPresupuesto === null ? 'N/A'
            : parseFloat(totalPresupuesto).toFixed(2) }
        </TicketGridCell>

        <TicketGridCell show={columnasVisibles.region}>{ticket.region}</TicketGridCell>

        <TicketGridCell show={columnasVisibles.subRegion}>{ticket.subRegion}</TicketGridCell>

        <TicketGridCell show={columnasVisibles.base}>{ticket.base}</TicketGridCell>

        <TicketGridCell show={columnasVisibles.pais}>{ticket.pais}</TicketGridCell>

        <TicketGridCell show={columnasVisibles.centroCostos}>{ticket.centro_costos}</TicketGridCell>

        <TicketGridCell show={columnasVisibles.centroBeneficios}>
          {ticket.centro_beneficios}
        </TicketGridCell>

        <TicketGridCell show={columnasVisibles.responsable1}> {ticket.responsable1}</TicketGridCell>

        <TicketGridCell show={columnasVisibles.enTaller}>
          <EnTaller enTaller={ticket.en_taller} />
        </TicketGridCell>

        <TicketGridCell show={columnasVisibles.fechaPrometida}>
          {ticket.fecha_prometida ? Timezone.getDateForClient(ticket.fecha_prometida, 'YYYY-MM-DD HH:mm:ss', 'L') : ""}
        </TicketGridCell>

        <TicketGridCell show={columnasVisibles.diasReparacion}>
          {ticket.dias_reparacion ? ticket.dias_reparacion : ''}
        </TicketGridCell>
        <TicketGridCell show={columnasVisibles.mttTotal}>{ticket.mtt_total}</TicketGridCell>

        <TicketGridCell show={columnasVisibles.mttParcial}>{ticket.mtt_parcial}</TicketGridCell>

        <TicketGridCell show={columnasVisibles.tiempoEnTaller}>
          {formatTiempoEnTallerGrilla(ticket.tiempo_en_taller_segundos)}
        </TicketGridCell>

        <TicketGridCell show={columnasVisibles.encuestaSatisfaccion}>
          {ticket.encuesta_satisfaccion_nivel}
        </TicketGridCell>

        <TicketGridCell show={columnasVisibles.fechaRealizado}>
          {ticket.fecha_hora_realizado
            ? Timezone.getDateForClient(ticket.fecha_hora_realizado, 'YYYY-MM-DD HH:mm:ss', 'L')
            : ''}
        </TicketGridCell>

        <TicketGridCell show={columnasVisibles.fechaHoraTurno}>
          {ticket.fecha_hora_turno
            ? Timezone.getDateForClient(ticket.fecha_hora_turno, 'YYYY-MM-DD HH:mm:ss', 'L')
            : ''}
        </TicketGridCell>

        <TicketGridCell show={columnasVisibles.abono}>
          {ticket.abono === "1"
            ? intl.formatMessage({ id: 'ticketsGrid.column.abono,si', defaultMessage: 'Si' })
            : intl.formatMessage({ id: 'ticketsGrid.column.abono.no', defaultMessage: 'No' })}
        </TicketGridCell>

        <TicketGridCell show={columnasVisibles.tipoModelo}>{ticket.modelo_tipo}</TicketGridCell>

        <TicketGridCell show={columnasVisibles.acciones}>
          {(() => {
            const centroCostoId = ticket.centro_costos ? (ticket.centro_costos.id || ticket.centro_costos) : null;
            const tienePermisoGestionCC = props.permissions && props.permissions.ticketsGestionCC;
            const puedeEditarCC = !centroCostoId || !tienePermisoGestionCC || (props.usuarioCCsGestionTickets && props.usuarioCCsGestionTickets.includes(centroCostoId));
            
            if (tienePermisoGestionCC && !puedeEditarCC) {
              return null;
            }
            return (
              <button
                className="action edit btn btn-sm btn-icon btn-dt-grid text-success"
                title={intl.formatMessage({
                  id: 'ticketsGrid.column_actions.button_title_trabajar_con_ticket',
                  defaultMessage: 'Trabajar con ticket',
                })}
                data-togle="tooltip"
                data-placement="top"
              >
                <i className="fa fa-pencil fa-xs"></i>
              </button>
            );
          })()}
        </TicketGridCell>
      </TableRow>
    </>
  );
};

const getAvatarTipo = (tipo) => {
  switch (tipo) {
    case "PREVENTIVO":
      return "paleta-preventivo";
    case "VENCIMIENTO":
      return "paleta-vencimiento";
    case "GESTORIA":
      return "paleta-gestoria";
    case "CORRECTIVO":
      return "paleta-correctivo";
    default:
      break;
  }
};


const EnTaller = ({ enTaller }) => {
  const intl = useIntl();

  if (enTaller === "1") {
    return (
      <div className="text-center default dt-info-icon">
        <i
          className="ft-check"
          data-togle="tooltip"
          data-placement="top"
          title={intl.formatMessage({
            id: 'ticketsGrid.column_taller.icon_default.label_taller_si_sin_verificacion',
            defaultMessage: 'SI - Sin Verificación',
          })}
        ></i>
      </div>
    );
  } else if (enTaller === "2") {
    return (
      <div className="text-center success dt-info-icon">
        <i
          className="ft-check"
          data-togle="tooltip"
          data-placement="top"
          title={intl.formatMessage({
            id: 'ticketsGrid.column_taller.icon_success.label_taller_si_verificado_gps',
            defaultMessage: 'SI - Verificado GPS',
          })}
        ></i>
      </div>
    );
  } else if (enTaller === "3") {
    return (
      <div className="text-center danger dt-info-icon">
        <i
          className="ft-check"
          data-togle="tooltip"
          data-placement="top"
          title={intl.formatMessage({
            id: 'ticketsGrid.column_taller.icon_danger.label_taller_no_verificado_gps',
            defaultMessage: 'No - Verificado GPS',
          })}
        ></i>
      </div>
    );
  } else {
    return '';
  }
};

const GetEntidadIcon = ({ ticket }) => {
  if (ticket.llanta_id !== null) {
    return (
      <img
        src="/images/llantas/tire.svg"
        style={{ height: '16px', width: '16px', marginRight: '4px', marginBlockEnd: '4px' }}
      ></img>
    );
  }

  if (ticket.movil_id !== null) {
    return <i className="la la-car" style={{ marginRight: '3px' }}></i>;
  }

  if (ticket.persona_id !== null) {
    return <i className="la la-user" style={{ marginRight: '3px' }}></i>;
  } else {
    return <i className="la la-dog" style={{ marginRight: '3px' }}></i>;
  }
};

export default TicketsGridTableRow;
